export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Instrumentation, control and automation technicians, control systems, DCS and SCADA engineers, control room operators, maintenance and reliability staff, system integrators and advanced students of control and automation engineering.',
  ],
  ['Content depth?', 'From fundamentals to professional-level control, supervision, communications and troubleshooting.'],
  [
    'Is it vendor-specific?',
    'No. It is vendor-neutral and based on internationally used concepts and terminology.',
  ],
  [
    'Format?',
    'Professional PDF technical reference files with instant access. It is not software, a simulator, editable spreadsheets, configuration files or a course with a certificate.',
  ],
  [
    'Does it replace site procedures?',
    'No. It does not replace site procedures, management of change, manufacturer documentation or the judgment of qualified personnel. Never make changes to a control system in service without authorization.',
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
